import { z } from 'zod';

/**
 * Klocki argumentów narzędzi MCP wspólne dla `contracts/mcp.ts` (rejestr, narzędzia Fal 5–9) i `contracts/mcp-daily.ts`
 * (codzienna praca przez MCP, Fala 10). Osobny plik, żeby oba moduły mogły z nich korzystać bez cyklu importów.
 */

/** Najwięcej wyników na stronę w narzędziach list. */
export const MCP_LIST_LIMIT_MAX = 50;

export const idempotencyKeySchema = z
  .string()
  .trim()
  .min(8, { message: 'idempotency_key: co najmniej 8 znaków (np. UUID)' })
  .max(128)
  .regex(/^[A-Za-z0-9._:-]+$/, { message: 'idempotency_key: litery, cyfry i . _ : -' });

export const mcpLimitArg = z.number().int().min(1).max(MCP_LIST_LIMIT_MAX).default(20);
export const mcpCursorArg = z.string().max(200).optional();
export const mcpQueryArg = z.string().trim().min(1).max(200);

/** Najdłuższa notatka agenta (`note`) w narzędziu mutującym. */
export const MCP_NOTE_MAX = 1000;

/**
 * `note` w narzędziach mutujących (Fala 10, DECISIONS 2026-10-07 „Wszystko z codziennej pracy da się zlecić agentowi
 * przez MCP”): krótki opis prośby osoby, którą agent wykonuje („Sebastian: dodaj klienta TeckWrap i ustaw stawkę”).
 * Trafia do Historii AI (polecenie, które wywołało działanie) — nie jest poleceniem dla systemu i nie zmienia danych.
 */
export const mcpNoteArg = z.string().trim().min(1).max(MCP_NOTE_MAX).optional();

/**
 * `expected_version` kontaktu (przegląd Fali 12): `get_client` zwraca dwie wersje — klienta (`client.version`) i każdego
 * kontaktu (`contacts[].version`). Narzędzia kontaktu porównują wersję KONTAKTU; opis trafia do JSON Schema w
 * `tools/list`, żeby model nie podawał wersji klienta (pętla CONFLICT).
 */
export const mcpContactVersionArg = z
  .number()
  .int()
  .positive()
  .describe('version kontaktu z get_client → contacts[].version (nie wersja klienta); inna = CONFLICT');
